import { render, staticRenderFns } from "./videoTypeList.vue?vue&type=template&id=b45cc71c"
import script from "./videoTypeList.vue?vue&type=script&lang=js"
export * from "./videoTypeList.vue?vue&type=script&lang=js"
import style0 from "./videoTypeList.vue?vue&type=style&index=0&id=b45cc71c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports